import { Box, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { EntityMenuItem } from '../../reducers/messagingSlice';
import HypothesisCartItemModGroups from './HypothesisItemModGroups';
import { ModifierCountGutter } from './ModifierCount';

interface IChildModGroup {
  hypothesisCartItemModifier: EntityMenuItem;
  /** HITL-1757: print a count as `4x sugar` on one line, not N repeated rows. */
  showsCounts?: boolean;
  /** HITL-1757: the item has a count somewhere; keep the gutter on this line. */
  hasCountGutter?: boolean;
}

interface IChildModGroupStyling {
  hasChildren: boolean;
  isSelected?: boolean;
}

const useStyles = makeStyles<Theme, IChildModGroupStyling>((theme) => ({
  itemNameClass: {
    wordBreak: 'break-all',
    fontSize: `${theme.spacing(1.5)} !important`,
  },
  childModGroupClass: {
    fontSize: theme.spacing(1.5),
    paddingBottom: ({ hasChildren }) => (hasChildren ? theme.spacing(1) : 0),
  },
  itemPriceClass: {
    fontSize: `${theme.spacing(1.5)} !important`,
    paddingLeft: theme.spacing(2),
  },
}));

export default function HypothesisChildModGroup({
  hypothesisCartItemModifier,
  showsCounts = false,
  hasCountGutter = false,
}: IChildModGroup) {
  const { itemNameClass, childModGroupClass } = useStyles({
    hasChildren: true,
  });

  return (
    <div className={`cartitem-child-modgroup ${childModGroupClass}`}>
      <div key={hypothesisCartItemModifier.id}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          {showsCounts ? (
            <Typography variant="subtitle2" className={itemNameClass}>
              {hasCountGutter && (
                <ModifierCountGutter
                  quantity={hypothesisCartItemModifier.quantity || 1}
                />
              )}
              {hypothesisCartItemModifier.name}
            </Typography>
          ) : (
            Array.from({
              length: hypothesisCartItemModifier.quantity || 1,
            }).map((_, index) => (
              <Typography variant="subtitle2" className={itemNameClass}>
                {hypothesisCartItemModifier.name}
              </Typography>
            ))
          )}
        </Box>
        {hypothesisCartItemModifier && hypothesisCartItemModifier.children && (
          <HypothesisCartItemModGroups
            hypothesisCartItemModGroups={hypothesisCartItemModifier.children}
            showsCounts={showsCounts}
            hasCountGutter={hasCountGutter}
          />
        )}
      </div>
    </div>
  );
}
